<div class="search-wrapper">
  <nz-input-group [nzSuffix]="inputClearTpl" [nzPrefix]="suffixIconSearch">
    <input
      nz-input
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearch($event)"
      [placeholder]="placeholder" />
  </nz-input-group>

  <ng-template #inputClearTpl>
    @if (searchTerm) {
      <span
        nz-icon
        class="ant-input-clear-icon"
        tabindex="0"
        nzTheme="fill"
        nzType="close-circle"
        (click)="clearSearch()"
        (keyup.enter)="clearSearch()">
      </span>
    }
  </ng-template>

  <ng-template #suffixIconSearch>
    <span nz-icon nzType="search"></span>
  </ng-template>
</div>
